import React from "react";
import Navbar from "../Navbar";
import { Link, useParams } from "react-router-dom";

const PaymentSuccess = () => {

  const reference = useParams('ref')
  // console.log(reference)
  return (
    <>
      <Navbar />
      <div className=" flex flex-col justify-center items-center h-[660px] py-24 my-auto text-white  w-full">
        <div className="bg-brand_jaguar h-[400px] flex flex-col justify-start text-center  items-center w-[300px] lg:w-[400px]">
          <h1 className="text-2xl py-2 text-black font-semibold bg-brand_yellow w-full">
            Payment Success
          </h1>
          <div className="py-3">
            <img src="https://cdn-icons-png.flaticon.com/128/2550/2550322.png" className="h-[50px]" alt="" />
          </div>
          <div className="text-center ">
            <h1 className="py-16 px-8">
              Congratulation on starting your journey and Thank you for trusting
              us
            </h1>
            <Link to='/mycourses' className="underline text-brand_yellow">Go to Courses</Link>
            <h1>Reference - {reference.ref}</h1>
          </div>
        </div>

        <div className="text-white text-center my-2 bg-brand_jaguar  w-[300px] lg:w-[400px]">
          Guaranteed Safe & Secure checkout
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
